const ACTIONS_CONTAINER_DIRECTION_CLASSES = {
  DEFAULT: 'flex-row',
  REVERSE: 'flex-row-reverse',
} as const;

const DEFAULT_MENU_CLASSES = {
  ACTIONS_CONTAINER: 'flex items-center gap-2',
  LIST_CONTAINER: 'flex w-full items-end justify-between gap-2',
} as const;

const DISPLAY_NAMES = {
  ACTIONS: 'TabsMenuActions',
  ACTIONS_CONTAINER: 'TabsMenuActionsContainer',
  WITH_NAV: 'TabsMenuWithNav',
} as const;

const DIVIDER_CLASS = 'mb-4 border-b border-gray-300';

const MENU_DATA_ATTRIBUTES = {
  VISIBLE: 'data-visible',
} as const;

export {
  ACTIONS_CONTAINER_DIRECTION_CLASSES,
  DEFAULT_MENU_CLASSES,
  DISPLAY_NAMES,
  DIVIDER_CLASS,
  MENU_DATA_ATTRIBUTES,
};
